import { FC, useMemo } from "react";
import { HStack, Icon, Text } from "@chakra-ui/react";

import { BankCardIcon } from "../../../../icons";

interface Props {
  name: string;
  isError: boolean;
}

export const PaymentBlockCardDetails: FC<Props> = ({ name, isError }) => {
  const { text, textVariant, iconColor } = useMemo(() => {
    let text = "Способ оплаты не добавлен";
    let textVariant: "gray" | "brand" = "gray";
    let iconColor = "gray.600";

    if (name) {
      text = name;
      textVariant = "brand";
      iconColor = "brand.500";
    }

    return { text, textVariant, iconColor } as const;
  }, [name]);

  if (isError) {
    return (
      <Text variant="brand" fontSize={14}>Не удалось загрузить способы оплаты</Text>
    );
  }

  return (
    <HStack mt="1px">
      <Icon as={BankCardIcon} boxSize="24px" color={iconColor} />
      <Text variant={textVariant}>{text}</Text>
    </HStack>
  );
};
